import { render, staticRenderFns } from "./System-polling.vue?vue&type=template&id=9f31b876&scoped=true&"
import script from "./System-polling.vue?vue&type=script&lang=js&"
export * from "./System-polling.vue?vue&type=script&lang=js&"
import style0 from "./System-polling.vue?vue&type=style&index=0&id=9f31b876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f31b876",
  null
  
)

export default component.exports